module.exports = "div.modal-title{cursor:move}h5{margin-left:10px;width:100%}\n"